import React, { useState } from 'react';
import { LogIn, Eye, EyeOff } from 'lucide-react';

const LoginScreen = ({ onLogin, loading }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    try {
      await onLogin(username, password);
    } catch (error) {
      const detail = error?.response?.data?.detail;
      setErrorMsg(typeof detail === 'string' ? detail : 'Invalid username or password');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#E8F2FC] to-[#EEF9E8] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/assets/logo.png" alt="Premier Carbonic" className="h-20 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Premier Carbonic</h1>
          <p className="text-[#156ACA] font-medium">Production Management System</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {errorMsg ? (
            <div
              className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded-lg text-sm"
              data-testid="login-error"
              role="alert"
            >
              {errorMsg}
            </div>
          ) : null}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg"
              placeholder="Enter username"
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="username"
              spellCheck={false}
              required
              data-testid="login-username"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                placeholder="Enter password"
                required
                data-testid="login-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#156ACA] hover:bg-[#0F5299] text-white font-semibold py-3 px-4 rounded-lg shadow-lg transition-colors disabled:opacity-50 flex items-center justify-center"
            data-testid="login-submit-btn"
          >
            {loading ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            ) : (
              <>
                <LogIn className="h-5 w-5 mr-2" />
                Login
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
